<template>
  <AntRow>
    <AntCol
      :sm="{ span: 24, offset: 0 }"
      :md="{ span: 20, offset: 2 }"
      :lg="{ span: 16, offset: 4 }"
    >
    <AntRadioGroup
      :value="selectedLoginFunction"
      class="login-function-buttons"
      buttonStyle="solid"
      @change="onChangeLoginFunction"
    >
      <AntRadioButton class="login-function-button" value="login" block>login</AntRadioButton>
      <AntRadioButton class="login-function-button" value="doLoginAndLaunchGame" block>doLoginAndLaunchGame</AntRadioButton>
    </AntRadioGroup>

      <FormTemplate
        :formFields="formFields"
        :formState="formState"
        :onSubmit="onSubmit"
        buttonText="Login"
      />
      <AntAlert
        v-if="!!alertState.message"
        :type="alertState.type"
        :message="alertState.message"
        showIcon
        @close="() => {}"
      >
        <!-- <template #description>
          <div v-html="warningMessages.join('<br>')" />
        </template> -->
      </AntAlert>
    </AntCol>
  </AntRow>
</template>

<script>
import {
  ref,
  reactive,
  watch,
  computed,
  onBeforeMount,
} from 'vue'

import { useRouter } from 'vue-router'
import axios from 'axios'
import { isEqual } from 'lodash'

import {
  Row as AntRow,
  Col as AntCol,
  Radio as AntRadio,
  Alert as AntAlert,
} from 'ant-design-vue'

import { getAllPlatformList, getGameListByPlatform } from '@/api/gas'
import { getUser, updateUser } from '@/api/tssw'

import { AWC_ENV_LIST } from '@/constants/index'

import {
  AGENT_CONFIG,
  DEFAULT_BET_LIMIT,
  USERID_FIELD,
  BETLIMIT_FIELD,
  LANGUAGE_FIELD,
  EXTERNALURL_ISMOBILELOGIN_AUTOBETMODE_ODDSMODE_FIELDS,
} from '@/constants/tssw'

import FormTemplate from '@/components/AgentManagement/FormTemplate'

export default {
  name: 'Login',
  components: {
    AntRow,
    AntCol,
    AntRadioButton: AntRadio.Button,
    AntRadioGroup: AntRadio.Group,
    AntAlert,
    FormTemplate,
  },
  props: {
    awcEnv: String,
    requestResponseData: Object,
  },
  emits: ['changeLoginUserData'],
  inheritAttrs: false,
  setup(props, { emit }) {
    const router = useRouter()

    const selectedLoginFunction = ref('login')
    const requestResponseData = reactive(props.requestResponseData)

    const formState = reactive({})
    const alertState = reactive({})

    const platformOptions = ref([])
    const gameCodeList = ref([])
    const gameTypeOptions = ref([])
    const gameCodeOptions = ref([])

    const getPlatformOptions = async () => {
      const { data: platformList = [] } = await getAllPlatformList()
      platformOptions.value = platformList.map(platform => ({ label: platform, value: platform }))
    }

    const PLATFORM_GAMETYPE_FIELDS = computed(() => [
      {
        id: 'platform',
        label: 'platform',
        defaultValue: undefined,
        placeholder: 'SEXYBCRT',
        element: 'select',
        options: platformOptions.value,
        loading: !platformOptions.value.length,
        disabled: !platformOptions.value.length,
        showSearch: true,
        onChange: async (value) => {
          gameTypeOptions.value = []
          gameCodeOptions.value = []

          const { data: gameCodeListData } = await getGameListByPlatform(value)
          gameCodeList.value = gameCodeListData
          console.log('gameCodeList', gameCodeList.value)

          const gameTypeList = gameCodeListData.reduce((acc, gameCode) => {
            const arr = gameCode.split('-')
            let gameType = arr[1]// eslint-disable-line prefer-destructuring
            if (arr.length === 4) gameType = arr[2] // eslint-disable-line prefer-destructuring
            if (gameType === 'FISH') gameType = 'FH'
            if (!acc.includes(gameType)) acc.push(gameType)
            return acc
          }, [])

          gameTypeOptions.value = gameTypeList.map(i => ({ label: i, value: i }))
          formState.gameType = gameTypeOptions.value[0]?.value
        },
      },
      {
        id: 'gameType',
        label: 'gameType',
        defaultValue: formState.gameType,
        element: 'select',
        options: gameTypeOptions.value,
        loading: formState.platform && !gameTypeOptions.value.length,
        disabled: !gameTypeOptions.value.length,
        showSearch: true,
      },
    ])

    // watch gameCodeList.value[0] 代表變更了新的 platform
    watch([() => gameCodeList.value[0], () => formState.gameType], async ([, newGameType]) => {
      gameCodeOptions.value = gameCodeList.value.filter((gameCode) => {
        const arr = gameCode.split('-')
        let gameType = arr[1]// eslint-disable-line prefer-destructuring
        if (arr.length === 4) gameType = arr[2] // eslint-disable-line prefer-destructuring
        if (gameType === 'FISH') gameType = 'FH'
        return gameType === newGameType
      }).map(i => ({ label: i, value: i }))

      formState.gameCode = gameCodeOptions.value[0]?.value
    })

    const formFieldsMap = computed(() => ({
      login: [
        {
          ...USERID_FIELD[0],
          rules: [
            ...USERID_FIELD[0].rules,
            {
              required: true,
              message: 'Required',
            },
          ],
        },
        {
          ...BETLIMIT_FIELD[0],
          placeholder: DEFAULT_BET_LIMIT,
        },
        ...PLATFORM_GAMETYPE_FIELDS.value,
        {
          id: 'gameForbidden',
          label: 'gameForbidden',
          defaultValue: undefined,
          element: 'input',
          placeholder: '{"JDBFISH":{"FH":["ALL"]}}',
          rules: [
            {
              validator: (rule, value) => {
                if (value) {
                  try {
                    const parseValue = JSON.parse(value)
                    return Promise.resolve(parseValue)
                  } catch (error) {
                    return Promise.reject(new Error('Please enter the correct format'))
                  }
                }
                return Promise.resolve()
              },
            },
          ],
        },
        ...LANGUAGE_FIELD,
        ...EXTERNALURL_ISMOBILELOGIN_AUTOBETMODE_ODDSMODE_FIELDS,
      ],
      doLoginAndLaunchGame: [
        {
          ...USERID_FIELD[0],
          rules: [
            ...USERID_FIELD[0].rules,
            {
              required: true,
              message: 'Required',
            },
          ],
        },
        {
          ...BETLIMIT_FIELD[0],
          placeholder: '{"SEXYBCRT":{"LIVE":{"limitId":[280301,280302,280303]}}}',
        },
        ...PLATFORM_GAMETYPE_FIELDS.value.map(f => ({
          ...f,
          rules: [
            {
              required: true,
              message: 'Required',
            },
          ],
        })),
        {
          id: 'gameCode',
          label: 'gameCode',
          defaultValue: formState.gameCode,
          element: 'select',
          options: gameCodeOptions.value,
          loading: formState.platform && !gameTypeOptions.value.length,
          disabled: !gameTypeOptions.value.length,
          showSearch: true,
          rules: [
            {
              required: true,
              message: 'Required',
            },
          ],
        },
        {
          id: 'hall',
          label: 'hall',
          defaultValue: undefined,
          element: 'input',
          placeholder: 'SEXY',
        },
        ...LANGUAGE_FIELD,
        ...EXTERNALURL_ISMOBILELOGIN_AUTOBETMODE_ODDSMODE_FIELDS,
        {
          id: 'isLaunchGameTable',
          label: 'isLaunchGameTable',
          defaultValue: undefined,
          element: 'checkbox',
          placeholder: 'true',
        },
        {
          id: 'gameTableId',
          label: 'gameTableId',
          defaultValue: undefined,
          element: 'input',
        },
      ],
    }))

    const formFields = computed(() => [...formFieldsMap.value[selectedLoginFunction.value]])

    onBeforeMount(getPlatformOptions)

    const onChangeLoginFunction = (e) => {
      const { value } = e.target
      selectedLoginFunction.value = value

      formFields.value.length = 0
      formFields.value.push(...formFieldsMap.value[value])

      const platformIdx = formFields.value.findIndex(({ id }) => id === 'platform')
      if (!formFields.value[platformIdx].options?.length) {
        formFields.value[platformIdx].options = platformOptions.value
        formFields.value[platformIdx].loading = false
      }
    }

    const onSubmit = async (formState) => { // eslint-disable-line no-shadow
      const { awcEnv: tsswAwcEnv } = props
      let awcEnv = tsswAwcEnv
      if (!tsswAwcEnv.startsWith('UAT_')) [awcEnv] = tsswAwcEnv.split('_') // UAT_AWS05 => UAT_AWS05, AWCA_PR => AWCA, AWS03_PR => AWS03

      const {
        userId,
        betLimit,
        autoBetMode,
      } = formState

      const { data: getUserData, status, message } = await getUser({ userId, env: tsswAwcEnv })

      if (status === 'success') {
        const URL = `${AWC_ENV_LIST[awcEnv].domain}/wallet/${selectedLoginFunction.value}`

        const requestData = {
          cert: AGENT_CONFIG[tsswAwcEnv].cert,
          agentId: AGENT_CONFIG[tsswAwcEnv].agentId,
          ...formState,
          ...(autoBetMode != null && { autoBetMode: autoBetMode ? '1' : '0' }),
        }

        const { data: { data: awcData } } = await axios.post(`/proxy/${URL}`, requestData)

        if (awcData) {
          requestResponseData.url = URL
          requestResponseData.request = JSON.stringify(requestData)
          requestResponseData.response = JSON.stringify(awcData)

          if (awcData.status === '0000') {
            alertState.type = 'success'
            alertState.message = `User ID: ${userId} login successfully`

            emit('changeLoginUserData', {
              ...getUserData,
              loginUrl: awcData.url,
              loginFunction: selectedLoginFunction.value,
              loginRequestData: requestData,
            })

            if (betLimit) {
              const formBetLimit = JSON.parse(betLimit)
              const userBetLimit = JSON.parse(getUserData.betLimit || '{}')

              let shouldUpdateBetlimit = false
              Object.entries(formBetLimit).forEach(([platform, platformBetLimit]) => {
                if (!isEqual(userBetLimit[platform], platformBetLimit)) {
                  shouldUpdateBetlimit = true
                  userBetLimit[platform] = platformBetLimit
                }
              })

              if (shouldUpdateBetlimit) {
                const { data: updateUserData } = await updateUser({
                  userId,
                  env: tsswAwcEnv,
                  betLimit: JSON.stringify(userBetLimit),
                })
                emit('changeLoginUserData', updateUserData)
              }
            }

            const prevRoute = router.getRoutes().find(({ path }) => path === window.history.state.back)
            if (prevRoute?.meta?.needLogin) {
              router.back()
            } else {
              router.push('/tssw/user-settings')
            }
          } else {
            alertState.type = 'error'
            alertState.message = JSON.stringify(awcData)
          }
        }
      } else {
        alertState.type = 'error'
        alertState.message = message
      }
    }

    return {
      formFields,
      formState,
      alertState,
      selectedLoginFunction,
      onChangeLoginFunction,
      onSubmit,
    }
  },
}
</script>

<style scoped>
.login-function-buttons {
  display: flex;
  margin-bottom: 24px;
}

.login-function-button {
  width: 100%;
  text-align: center;
}
</style>
